import {camelCaseToTitleCase, getDescendantProp} from "@/utils/propDisplay";
import {checkInActionMap} from "@/utils/const";
import swal from "sweetalert";
import {checkIn} from "@/utils/api";

export const processCheckInUser = (userData, userType) => {
    return new Promise((resolve, reject) => {
        const hasWarnings = Array.isArray(userData.checkInNotes) && userData.checkInNotes.length > 0;

        const wrapper = document.createElement('div');

        const userInfo = document.createElement('p');
        userInfo.style.textAlign = 'left';
        for(const property of [["firstName"], ["lastName"], ["hackerApplication.age", "age"], ["email"], ["hackerApplication.shirtSize", "shirtSize"]]) {
            const propPath = property[0];
            const displayText = property[1] ?? property[0];

            const userInfoHeader = document.createElement('strong');
            userInfoHeader.textContent = camelCaseToTitleCase(displayText) + ": ";
            userInfo.appendChild(userInfoHeader);

            userInfo.appendChild(document.createTextNode(getDescendantProp(userData, propPath)));
            userInfo.appendChild(document.createElement('br'));
        }

        wrapper.appendChild(userInfo);

        if(hasWarnings) {
            const userWarnings = document.createElement('p');
            userWarnings.style.textAlign = 'left';

            const userWarningHeader = document.createElement('p');
            userWarningHeader.style.fontWeight = 'bold';
            userWarningHeader.textContent = 'THIS USER HAS OUTSTANDING ACTIONS! Ensure they are ALL completed before check in:';

            userWarnings.appendChild(userWarningHeader);

            const userWarningList = document.createElement('ul');

            for(const warning of userData.checkInNotes) {
                const userWarningItem = document.createElement('li');
                userWarningItem.textContent = checkInActionMap[warning] ?? warning;

                userWarningList.appendChild(userWarningItem);
            }

            userWarnings.appendChild(userWarningList);
            wrapper.appendChild(userWarnings);
        }

        swal({
            text: "Successfully found user!",
            content: wrapper,
            icon: 'info',
            buttons: {
                cancel: true,
                confirm: "Check In"
            },
            dangerMode: hasWarnings
        }).then((confirmCheckIn) => {
            if(confirmCheckIn) {
                checkIn(userData._id, userType).then((result) => {
                    if (result.success) {
                        swal('Success', `The user ${userData.firstName} ${userData.lastName} has been checked in.`, 'success');
                        return resolve(true);
                    }
                    else {
                        swal('Warning', 'Unable to check in user.', 'error');
                        return resolve(false);
                    }
                }).catch((e) => {
                    console.error("Encountered error sending check in request.", e);
                    return resolve(false);
                });
            }
            else {
                swal('Warning', 'Check-in cancelled. The user is NOT checked in!', 'warning');
                return resolve(false);
            }
        });
    });
}